import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const baseURL = BASE_API_URL;

export const SmeSlice = createSlice({
 name: "Nominationlist",
 initialState: {
  error: false,
  trainingSkills: [],
  trainingList: [],
  courseWiseList: [],
  approvedCountSME: 0,
  rejectedCountSME: 0,
  nominatedCountSME: 0,
  isSMEUSerPresent: false,
  isLoader: false,
  isDataSentSuccess: false,
  isDataSentFailure:false,
 },
 reducers: {
  setTrainingSkills: (state, { payload }) => {
   state.error = false;
   state.trainingSkills = payload;
  },
  setError: (state) => {
   state.error = true;
  },
  setTrainingList: (state, { payload }) => {
   state.error = false;
   state.isLoader = false;
   state.trainingList = payload;
   console.log("payload from SMESLICE-> ",payload);
  },
  // updateStatus: (state, { payload }) => {
  //  state.error = false;
  //  state.trainingSkills.map((val, i) => {
  //   if (val.id == payload.id) {
  //    val.status = payload.status;
  //   }
  //  });
  // },
  setFilteredList: (state, { payload }) => {
   state.error = false;
   // let updatedData = state.trainingSkills.filter((item) => item.status === payload);
   state.trainingSkills = payload;
  },
  setCourseWiseList: (state, { payload }) => {
   state.error = false;
   state.courseWiseList = payload;
  },
  setSubmitStatus: (state, { payload }) => {
   state.error = false;
   state.courseWiseList.map((val, i) => {
    if (val.id == payload.id) {
     val.status = payload.status;
     val.reason = payload.reason;
    }
   });
   let updatedObjects = state.courseWiseList.filter((item) => item.status == 1);
   state.courseWiseList = updatedObjects;
  },

  setNominatedCountSME: (state, { payload }) => {
   state.nominatedCountSME = payload[0].nominationCount;
  },
  setLoader: (state, { payload }) => {
   state.isLoader = true;
   state.isDataSentSuccess = false;
   state.isDataSentFailure = false;
  },
  setDataSentSuccess: (state) =>{
    state.isLoader = false;
    state.isDataSentSuccess = true;
    state.isDataSentFailure = false;
  },
  setDataSentFailure: (state) =>{
    state.isLoader = false;
    state.isDataSentSuccess = false;
    state.isDataSentFailure = true;
  },
  setCountSME: (state, { payload }) => {
   state.rejectedCountSME = 0;
   state.approvedCountSME = 0;

   payload.result.map((val, i) => {
    if (val.status == "3") {
     state.rejectedCountSME = val.count;
    } else if (val.status == "2") {
     state.approvedCountSME = val.count;
    }
   });

  //  payload.result1.map((val, i) => {
  //   if (val.prevStatus == "2") {
  //    state.approvedCountSME += val.prev_count;
  //   }
  //  });
  },
  setSMEUser: (state, { payload }) => {
   if (payload > 0) {
    state.isSMEUSerPresent = true;
   }
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setTrainingSkills,
 setError,
 setTrainingList,
 updateStatus,
 setFilteredList,
 setCourseWiseList,
 setSubmitStatus,
 setNominatedCountSME,
 setCountSME,
 setSMEUser,
 setLoader,
 setDataSentSuccess,
 setDataSentFailure
} = SmeSlice.actions;

export default SmeSlice.reducer;

// export function getNominationList() {
//  return (dispatch) => {
//   Axios.get(`${baseURL}/fetchTrainingList`, {
//    headers: {
//     Authorization: localStorage.getItem("token"),
//     "Content-Type": "application/json",
//    },
//   })
//    .then((res) => {
//     dispatch(setTrainingList(res.data));
//     //dispatch(setCourseWiseList(res.data));
//     console.log("res from get nomination list", res.data);
//    })
//    .catch((err) => {
//     dispatch(setError(err));
//     console.error("error is", err);
//    });
//  };
// }

export function smeAction(actionChange, courseCode, date) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/updatingAction`,
      {
        actionChange,
        courseCode,
        date,
      },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        return dispatch(setSubmitStatus(actionChange));
      }).then(() => {
        return dispatch(getCountSME(courseCode, date)); // Will run after data is fetched
      })
      .then(() => {
        return dispatch(getFilterNominationList(courseCode, date)); // Return promise 
      })
      .catch((err) => {
        console.error("error is", err);
      });
  };
}

export function getFilterNominationList(course, date) {
  return (dispatch) => {
    dispatch(setLoader());
    return Axios.post(
      `${baseURL}/fetchSMEfilteredNominationList`,
      { course, date },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        res.data.map((val, i) => {
          val.sno = i + 1;
        });
        dispatch(setCourseWiseList(res.data));
        dispatch(setDataSentSuccess());
        console.log("res from get filtered nomination list", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        dispatch(setDataSentFailure());
        console.error("error is", err);
      });
  };
}

export function fetchWaitingForApprovalList(session, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/fetchWaitingForApprovalList`,
   { session, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    console.log("res in coursewiselist", res.data);
    // dispatch(setCourseWiseList(res.data));
    // setTrainingList(res.data);
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}
export function fetchSMEMonthData(username, month, year){
  return (dispatch) => {
        dispatch(setLoader());
     Axios.get(`${baseURL}/fetchTrainingListSME`, {
      headers: {
       Authorization: localStorage.getItem("token"),
       "Content-Type": "application/json",
      },
      params:{
        SMEId:username,
        month,
        year
      }
     })
      .then((res) => {
       res.data.map((val, i) => {
        val.id = i + 1;
       });
       dispatch(setTrainingList(res.data));
      })
      .catch((err) => {
       console.error("error is", err);
      });
  }
}
export function getNominatedCountSME(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getnominatedcountsme`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setNominatedCountSME(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}
export function getCountSME(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getcount`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setCountSME(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function checkUserPresent(username, accessToken) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/checkUserPresent`,
   { username },
   {
    headers: {
     Authorization: accessToken,
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setSMEUser(res.data[0].name_count));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}
